import React, { PureComponent, createRef } from 'react';
import debounce from 'lodash.debounce';

import FrameCommunicator from '@bit/bit.capsule.iframe.communicator';
import { Lifecycle, RemoteCapsule } from '@bit/amit.capsule-dev.remote-capsule';

import Editor from '../../organisms/editor';
import { CapsuleCtrl } from '../../atoms/capsule-ctrl';
import { PlaygroundFs, MemfsJson } from '../../state/files-store';

import { StaticPreview } from '../../organisms/static-preview';
import { FileExplorer } from '../../organisms/file-explorer';
import { HomepageTemplate } from '../../templates/homepage';
import { IPromisesAPI } from 'memfs/lib/promises';
import { RxTerm } from '../../organisms/terminal';
import { Unsubscribe } from 'redux';
import { IExample } from '../../state/example-type';

import { PlaygroundConfig } from './playground-config';
import { mapFilesToCapsule } from './file-mapping';

type PlaygroundState = {
	fs?: IPromisesAPI;

	files?: MemfsJson; //deprecated
	currentFilepath?: string;
	isModified: boolean;

	//capsule:
	capsule?: RemoteCapsule;
	capsuleFs?: IPromisesAPI; //@HACK
	rendered: boolean;
};

type PlaygroundProps = {
	config: PlaygroundConfig;
	example?: IExample;
	overrideFs?: PlaygroundFs;
	files?: MemfsJson; //@HACK!!
	bitId?: string; //consider adding to example
};

export class Playground extends PureComponent<PlaygroundProps, PlaygroundState> {
	constructor(props: PlaygroundProps) {
		super(props);

		this._fsUnsubscribe =
			props.overrideFs && props.overrideFs.subscribe(this.handlePlaygroundFsChanged);

		this.state = {
			files: props.files || mapFilesToCapsule(props.overrideFs, props.example),
			currentFilepath: props.example && props.example.mainFile,

			isModified: false,
			rendered: false,
		};
	}

	private capsuleRef = createRef<CapsuleCtrl>();

	//TODO - use communicator in player project
	private player = new FrameCommunicator({
		selfFrameId: window.name,
		targetFrameId: undefined,
		isDebugging: false,
	});

	componentWillReceiveProps(nextProps: PlaygroundProps) {
		const prevProps = this.props;

		if (
			(prevProps.example && prevProps.example.codeId) !==
			(nextProps.example && nextProps.example.codeId)
		) {
			//example changed. reset isModified
			this.setState({ isModified: false });
		}

		if (
			!!nextProps.example &&
			(prevProps.example && prevProps.example.mainFile) !==
				(nextProps.example && nextProps.example.mainFile)
		) {
			this.setState({ currentFilepath: nextProps.example.mainFile });
		}

		if (prevProps.overrideFs !== nextProps.overrideFs && nextProps.overrideFs) {
			this.setState({
				files: mapFilesToCapsule(nextProps.overrideFs, nextProps.example),
			});
		}
	}

	private _fsUnsubscribe?: Unsubscribe;
	componentDidUpdate(prevProps: PlaygroundProps) {
		const nextProps = this.props;

		if (prevProps.overrideFs !== nextProps.overrideFs && nextProps.overrideFs) {
			this._fsUnsubscribe && this._fsUnsubscribe();
			this._fsUnsubscribe = nextProps.overrideFs.subscribe(
				this.handlePlaygroundFsChanged
			);
		}
	}

	private handlePlaygroundFsChanged = () => {
		const { overrideFs, example } = this.props;
		if (!overrideFs) return;

		this.setState({
			files: mapFilesToCapsule(overrideFs, example),
			isModified: true,
		});
	};

	componentDidMount() {
		this.registerPlayerEvents();
	}

	//TODO - consider removing
	private registerPlayerEvents() {
		this.player.onMessage('devServerDisconnected', () => {
			const capsuleStatus = this.capsuleRef.current && this.capsuleRef.current.status;
			if (capsuleStatus !== Lifecycle.Connected) return;

			setTimeout(() => {
				this.reloadPreview();
			}, 200);
		});
	}

	reloadPreview = debounce(() => {
		if (!this.capsuleRef.current) return;
		this.capsuleRef.current.reload();
		this.setState({ isModified: true });
	}, 1000);

	private get rootViewDir() {
		const { overrideFs } = this.props;

		return overrideFs ? '.' : '/capsule';
	}

	private handleCapsuleChange = (capsule?: RemoteCapsule) => {
		//TODO - set capsuleFs?
		this.setState({ capsule });
	};

	private handleCapsuleFsChange = (fs?: IPromisesAPI) => {
		this.setState({ capsuleFs: fs });
	};

	private handleFileSelected = (filepath?: string) => {
		this.setState({ currentFilepath: filepath });
	};

	render() {
		const { example = {}, config, overrideFs, bitId } = this.props;

		const {
			files,
			currentFilepath,
			isModified,

			capsuleFs,
			capsule,
		} = this.state;

		const fs = (overrideFs && overrideFs.promises) || capsuleFs;

		const editor = <Editor fs={fs} filepath={currentFilepath} canWrite={config.canWrite} />;

		const player = (
			<>
				<CapsuleCtrl
					ref={this.capsuleRef}
					isVisible={isModified || !example.staticUrl}
					type={example.renderer}
					codeId={example.codeId}
					bitId={bitId}
					files={files}
					onFsChange={this.handleCapsuleFsChange}
					onCapsuleChange={this.handleCapsuleChange}
				/>
				{!isModified && example.staticUrl && <StaticPreview url={example.staticUrl} />}
			</>
		);

		const terminal = <RxTerm capsule={capsule} />;

		const fileExplorer = (
			<FileExplorer
				fs={fs}
				workDir={this.rootViewDir}
				selectedFile={currentFilepath}
				onFileSelected={this.handleFileSelected}
			/>
		);

		const controlBoard = null;
		// (
		// 	<ControlBoard
		// 		targetFs={targetFs}
		// 		onTargetChange={this.handleTargetChange}
		// 		capsule={capsule}
		// 		targetComponent={example.targetComponent}
		// 		workDir={this.examplesDir}
		// 	/>
		// );

		return (
			<HomepageTemplate
				layout={config.layout}
				fileExplorer={fileExplorer}
				editor={editor}
				player={player}
				terminal={terminal}
				controlBoard={controlBoard}
			/>
		);
	}
}
